export const composeValidators =
  (...validators: any) =>
  (value: any, allValues: any) =>
    validators.reduce(
      (error: string, validator: (value: string, allValues: any) => string | undefined) =>
        error || validator(value, allValues),
      undefined,
    );
